import styled from "styled-components";

export const StyledQuestionIconWrap = styled.div`
    margin-right: 16px;
`;
